import React, { useEffect, useState } from "react";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

export default function VerLiquidacionDeClientes({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [e, setE] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        const data = await appFetchJson(
          apiRoutes.liquidacionEjecucion.detail(id)
        );
        if (!cancelled) setE(data);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setErr("Error al cargar la liquidación.");
          setE(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const rows = [
    
    ["Código Liquidación", e?.codigoLiquidacion],
    ["Estado", e?.estadoNombre],
    ["Liquidación", e?.descripcion],

    ["Fecha", e?.dataFecha],
    ["Fecha Inicio", e?.dataFechaini],
    ["Fecha Fin", e?.dataFechafin],

    ["Remitos Procesados", e?.qnRemitosProc],
    ["Facturas", e?.qnFactura],
    ["Notas de Crédito", e?.qnNotaCredito],
    ["Clientes sin Facturar", e?.qnClieSinFacturar],

    ["Desc. Libre", e?.valorTotalDescLibe],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">
            Ejecución de Liquidación
          </h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">
              Cargando…
            </div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">
              {err}
            </div>
          )}

          {!loading && !err && e && (
            <div className="form-grid">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">
        {value !== null && value !== undefined && value !== ""
          ? value
          : <span className="text-gray-400">—</span>}
      </div>
    </div>
  );
}
